import styled from 'styled-components';
import { Avatar, CustomTypography } from '@shared/ui';
import { IUserGender } from '@shared/types';

const StyledUserName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const StyledUserNameInfo = styled.div`
  display: flex;
  color: #526077;
  flex-direction: column;
  span:first-child {
    color: black;
    font-weight: bold;
  }
`;

interface IUserAvatar {
  avatar: string;
  gender: IUserGender;
  name: string;
  username?: string;
}

export const UserAvatar = ({ username, name, gender, avatar }: IUserAvatar) => {
  return (
    <StyledUserName>
      <Avatar gender={gender} src={avatar} alt={username} />
      <StyledUserNameInfo>
        <CustomTypography color='black' fontSize={'1rem'} fontWeight={'500'} value={name} />
        <CustomTypography color='black' value={username} />
      </StyledUserNameInfo>
    </StyledUserName>
  );
};
